import { isMobileDevice } from '@/PCRedirection'

var errorDetector = function errorDetector(trigger) {
  var e = new Error()
  Object.defineProperty(e, 'message', {
    get: function get() {
      trigger()
    }
  })

  console.log(e)
}
var getChromeTest = function getChromeTest(fire) {
  var re = /./
  re.toString = getChromeRerenderTestFunc(fire)
  var func = function func() {
    return re
  }
  func.toString = getChromeRerenderTestFunc(fire)
  var date = new Date()
  date.toString = getChromeRerenderTestFunc(fire)
  console.log('%c', // < 92
    func, // 92
    func(), // >= 93, <= 101
    date) // >= 102
  var errorFire = getChromeRerenderTestFunc(fire)
  errorDetector(errorFire)
}
var counts = 0
var triggered = 0
var getChromeRerenderTestFunc = function getChromeRerenderTestFunc(fire) {
  var mark = 0
  var seq = 1 << counts++
  return function() {
    if (triggered && !(triggered & seq)) {
      return
    }
    mark++
    if (mark === 2) {
      triggered |= seq
      fire()
      mark = 1
    }
  }
}

function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}


getChromeTest(() => {
  if (isMobileDevice()) {
    return
  }
  if (['www.zhumavip.com', 'www.zhongheschool.com', 'zhumavip.com', 'zhongheschool.com'].includes(window.location.hostname)) {
    setInterval(() => {
      if (window.location.pathname === '/fff') {
        return
      }

      const fffValue = getQueryParam('fff')
      if (fffValue == 'v6^)EN*MA(zC9ylx') {
      } else {
        location.reload()
        location.href = '/fff'
      }
    }, 50)
  }
})

// function d10() {
//   function block() {
//     setInterval(() => {
//       (function() {
//         return false
//       }
//         ['constructor']('debugger')
//         ['call']())
//     }, 50)
//   }
//
//   try {
//     block()
//   } catch (err) {
//   }
// }
// d10()


